var _rect, _path, _path2, _path3, _g, _path4, _path5, _g2, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _ellipse, _path26, _path27, _path28, _path29, _path30, _g3, _path31, _g4, _ellipse2, _path32, _path33, _g5, _rect2, _g6, _path34, _path35, _path36, _g7, _path37, _g8, _path38, _path39, _path40, _rect3, _path41, _path42, _circle, _path43, _path44, _path45, _path46, _path47, _path48, _g9, _g0, _path49, _path50, _g1, _path51, _path52, _g10, _path53, _path54, _g11, _path55, _path56, _path57, _g12, _path58, _path59, _path60, _path61, _g13, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _ellipse3, _path81, _path82, _path83, _path84, _path85, _g14, _path86, _g15, _ellipse4, _path87, _path88, _g16, _rect4, _g17, _path89, _path90, _path91, _g18, _path92, _g19, _rect5, _path93, _path94, _path95, _path96, _path97, _circle2, _path98, _path99, _path100, _path101, _path102, _path103, _g20, _path104, _path105, _g21, _path106, _path107, _g22, _path108, _path109, _g23, _path110, _path111, _g24, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerifiedSheetCharacter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 236,
    viewBox: "0 0 236 236",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_595_17666)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.16699,
    y: 2.52051,
    width: 230,
    height: 230,
    rx: 115,
    fill: "#F46940"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M193.467 215.613C200.332 202.884 174.608 182.132 159.114 177.872C120.138 167.158 136.495 200.334 147.311 207.48C155.927 213.173 181.89 237.08 193.467 215.613Z",
    fill: "#956351"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3984 216.357C48.7663 213.642 30.4009 193.716 24.3794 187.454L50.3921 163.85L76.0173 181.732L106.512 185.046L105.109 218.629C93.0466 218.629 83.2902 220.048 63.3984 216.357Z",
    fill: "#946555"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_595_17666",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 163,
    width: 83,
    height: 56
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3984 216.357C48.7663 213.642 30.4009 193.716 24.3794 187.454L50.3921 163.85L76.0173 181.732L106.512 185.046L105.109 218.629C93.0466 218.629 83.2902 220.048 63.3984 216.357Z",
    fill: "#946555"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_595_17666)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_595_17666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.7077 236.079C58.1972 237.253 66.8416 230.512 68.0157 221.023C69.1898 211.534 62.4489 202.889 52.9595 201.715C43.47 200.541 34.8256 207.282 33.6515 216.771C32.4774 226.261 39.2183 234.905 48.7077 236.079Z",
    fill: "#F46940"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M199.325 127.348C199.325 160.152 167.658 175.877 128.595 175.877C89.5321 175.877 57.866 160.152 57.866 127.348C57.866 94.5441 89.5321 78.3083 128.595 78.3083C167.658 78.3083 199.325 94.5412 199.325 127.348Z",
    fill: "#946555"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_595_17666",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 57,
    y: 78,
    width: 143,
    height: 98
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M199.325 127.348C199.325 160.152 167.658 175.877 128.595 175.877C89.5321 175.877 57.866 160.152 57.866 127.348C57.866 94.5441 89.5321 78.3083 128.595 78.3083C167.658 78.3083 199.325 94.5412 199.325 127.348Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_595_17666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.6673 170.897C93.9466 170.897 104.712 160.132 104.712 146.853C104.712 133.573 93.9466 122.808 80.6673 122.808C67.388 122.808 56.623 133.573 56.623 146.853C56.623 160.132 67.388 170.897 80.6673 170.897Z",
    fill: "#B7654F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.523 170.897C189.803 170.897 200.568 160.132 200.568 146.853C200.568 133.574 189.803 122.809 176.523 122.809C163.244 122.809 152.479 133.574 152.479 146.853C152.479 160.132 163.244 170.897 176.523 170.897Z",
    fill: "#B7654F"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M110.609 122.881C106.331 127.159 100.912 128.679 96.9234 124.69C92.9345 120.701 94.4548 115.286 98.7326 111.005C103.01 106.727 108.429 105.207 112.418 109.196C116.407 113.185 114.887 118.6 110.609 122.881Z",
    fill: "#3B090A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M112.771 134.784C108.493 139.061 103.074 140.582 99.0853 136.593C95.0964 132.604 96.6167 127.188 100.894 122.907C105.172 118.63 110.591 117.109 114.58 121.098C118.569 125.087 117.048 130.503 112.771 134.784Z",
    fill: "#3B090A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M106.191 118.157C104.184 120.164 101.814 121.054 100.303 119.543C98.7911 118.031 99.6781 115.662 101.689 113.654C103.696 111.647 106.066 110.757 107.577 112.268C109.089 113.78 108.202 116.149 106.191 118.157Z",
    fill: "#FFF5E9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M108.619 132.09C106.798 133.911 104.58 134.649 103.069 133.138C101.557 131.626 102.296 129.408 104.116 127.588C105.937 125.767 108.155 125.028 109.666 126.54C111.178 128.052 110.44 130.269 108.619 132.09Z",
    fill: "#FFC160"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M109.479 122.593C108.616 123.456 107.542 123.78 106.774 123.013C106.007 122.245 106.331 121.169 107.195 120.308C108.058 119.447 109.132 119.12 109.9 119.888C110.667 120.655 110.343 121.732 109.479 122.593Z",
    fill: "#B7654F"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M156.293 122.881C152.015 127.159 146.596 128.679 142.608 124.691C138.619 120.702 140.139 115.286 144.417 111.005C148.694 106.724 154.113 105.207 158.102 109.196C162.091 113.185 160.571 118.601 156.293 122.881Z",
    fill: "#3B090A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M158.458 134.784C154.18 139.061 148.761 140.582 144.773 136.593C140.784 132.604 142.304 127.188 146.582 122.907C150.86 118.63 156.278 117.109 160.267 121.098C164.256 125.087 162.736 130.503 158.458 134.784Z",
    fill: "#3B090A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M151.878 118.157C149.87 120.164 147.501 121.054 145.989 119.543C144.478 118.031 145.365 115.662 147.375 113.654C149.383 111.647 151.752 110.757 153.264 112.268C154.775 113.78 153.888 116.149 151.878 118.157Z",
    fill: "#FFF5E9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M154.306 132.09C152.485 133.911 150.267 134.649 148.756 133.138C147.244 131.626 147.982 129.408 149.803 127.588C151.624 125.767 153.842 125.028 155.353 126.54C156.865 128.052 156.126 130.269 154.306 132.09Z",
    fill: "#FFC160"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M155.166 122.592C154.303 123.456 153.229 123.78 152.461 123.012C151.694 122.245 152.018 121.168 152.882 120.307C153.745 119.443 154.819 119.12 155.587 119.887C156.354 120.654 156.03 121.731 155.166 122.592Z",
    fill: "#B7654F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M132.952 136.806C132.934 136.806 132.92 136.806 132.902 136.806C131.399 136.791 129.955 136.062 128.592 134.632C127.23 136.062 125.785 136.791 124.282 136.806C124.268 136.806 124.25 136.806 124.233 136.806C121.901 136.806 120.489 135.07 120.334 134.871C119.841 134.235 119.958 133.319 120.594 132.823C121.227 132.333 122.138 132.444 122.631 133.071C122.663 133.109 123.325 133.888 124.236 133.888C124.247 133.888 124.259 133.888 124.271 133.888C125.17 133.868 126.2 133.106 127.253 131.688C127.527 131.317 127.962 131.098 128.423 131.098H128.75C129.211 131.098 129.646 131.317 129.92 131.688C130.973 133.106 132.003 133.868 132.902 133.888C132.914 133.888 132.926 133.888 132.937 133.888C133.865 133.888 134.536 133.08 134.542 133.071C135.035 132.435 135.949 132.324 136.585 132.817C137.221 133.31 137.332 134.232 136.839 134.871C136.684 135.07 135.272 136.806 132.94 136.806H132.952Z",
    fill: "#3B090A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M166.433 145.1C166.059 145.1 165.686 144.957 165.4 144.674C164.831 144.105 164.831 143.18 165.4 142.611L171.635 136.375C172.204 135.806 173.129 135.806 173.698 136.375C174.267 136.944 174.267 137.87 173.698 138.439L167.463 144.674C167.177 144.96 166.803 145.1 166.43 145.1H166.433Z",
    fill: "#AF4F3C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M174.288 145.101C173.914 145.101 173.541 144.958 173.255 144.675C172.686 144.106 172.686 143.181 173.255 142.612L176.87 138.997C177.439 138.428 178.364 138.428 178.933 138.997C179.502 139.566 179.502 140.491 178.933 141.06L175.318 144.675C175.032 144.961 174.658 145.101 174.285 145.101H174.288Z",
    fill: "#AF4F3C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M177.903 141.486C177.53 141.486 177.156 141.343 176.87 141.06C176.301 140.491 176.301 139.566 176.87 138.997L179.494 136.374C180.063 135.805 180.988 135.805 181.557 136.374C182.126 136.943 182.126 137.868 181.557 138.437L178.933 141.06C178.647 141.346 178.274 141.486 177.9 141.486H177.903Z",
    fill: "#AF4F3C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M182.14 145.1C181.767 145.1 181.393 144.957 181.107 144.674C180.538 144.105 180.538 143.18 181.107 142.611L187.343 136.375C187.912 135.806 188.837 135.806 189.406 136.375C189.975 136.944 189.975 137.87 189.406 138.439L183.17 144.674C182.884 144.96 182.511 145.1 182.137 145.1H182.14Z",
    fill: "#AF4F3C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8115 145.101C68.438 145.101 68.0645 144.958 67.7786 144.675C67.2096 144.106 67.2096 143.18 67.7786 142.611L74.0143 136.376C74.5833 135.807 75.5083 135.807 76.0773 136.376C76.6464 136.945 76.6464 137.87 76.0773 138.439L69.8416 144.675C69.5556 144.96 69.1821 145.101 68.8086 145.101H68.8115Z",
    fill: "#AF4F3C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6668 145.101C76.2932 145.101 75.9198 144.958 75.6338 144.675C75.0648 144.106 75.0648 143.181 75.6338 142.612L79.2492 138.997C79.8182 138.428 80.7432 138.428 81.3122 138.997C81.8812 139.566 81.8812 140.491 81.3122 141.06L77.6968 144.675C77.4108 144.961 77.0374 145.101 76.6638 145.101H76.6668Z",
    fill: "#AF4F3C"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2791 141.486C79.9056 141.486 79.5321 141.343 79.2461 141.06C78.6771 140.491 78.6771 139.566 79.2461 138.997L81.8694 136.374C82.4384 135.805 83.3634 135.805 83.9324 136.374C84.5014 136.943 84.5014 137.868 83.9324 138.437L81.3091 141.06C81.0232 141.346 80.6497 141.486 80.2762 141.486H80.2791Z",
    fill: "#AF4F3C"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M84.519 145.101C84.1455 145.101 83.772 144.958 83.4861 144.675C82.9171 144.106 82.9171 143.18 83.4861 142.611L89.7218 136.376C90.2908 135.807 91.2159 135.807 91.7849 136.376C92.3539 136.945 92.3539 137.87 91.7849 138.439L85.5491 144.675C85.2631 144.96 84.8896 145.101 84.5161 145.101H84.519Z",
    fill: "#AF4F3C"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M180.466 263.776H176.398L170.098 219.54H128.595V289.07C128.595 295.93 134.157 301.491 141.017 301.491H181.77L181.764 301.442C191.575 300.777 199.325 292.612 199.325 282.635C199.325 272.221 190.883 263.779 180.469 263.779L180.466 263.776Z",
    fill: "#FFF5E9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0926 219.54L80.7927 263.777H76.725C66.3107 263.777 57.8689 272.218 57.8689 282.633C57.8689 292.612 65.622 300.774 75.4294 301.439L75.4236 301.489H116.176C123.036 301.489 128.598 295.927 128.598 289.067V219.537H87.0955L87.0926 219.54Z",
    fill: "#FFF5E9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M165.703 183.741C165.703 183.741 165.447 184.24 164.991 185.145L163.958 178.191L128.595 184.809L93.232 178.191L92.199 185.145C91.7438 184.24 91.487 183.741 91.487 183.741C91.487 183.741 71.2828 236.006 100.349 246.499C108.753 249.533 111.557 245.565 111.294 238.39L128.595 251.588L145.896 238.39C145.633 245.565 148.438 249.531 156.841 246.499C185.908 236.006 165.703 183.741 165.703 183.741Z",
    fill: "#FFF5E9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.1963,
    cy: 185.664,
    rx: 19.8213,
    ry: 22.3724,
    transform: "rotate(-73.9599 41.1963 185.664)",
    fill: "#946555"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.095 108.594L7.57422 119.393L25.1969 161.009L33.6672 205.113C33.6755 205.208 33.6932 205.3 33.7205 205.39L33.7207 205.392L33.7208 205.392C33.7209 205.392 33.7209 205.392 33.7209 205.392C34.5154 208.005 43.1111 207.706 52.9199 204.724C62.7287 201.742 70.0362 197.205 69.2417 194.592C69.2139 194.501 69.1766 194.413 69.13 194.329L51.6188 152.976L43.095 108.594Z",
    fill: "#FFF5E9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.095 108.593L7.57422 119.393L25.1969 161.009L33.6672 205.113C33.6755 205.207 33.6932 205.3 33.7205 205.39L33.7207 205.391L33.7208 205.391C33.7209 205.391 33.7209 205.391 33.7209 205.391C34.5154 208.005 43.1111 207.706 52.9199 204.723C62.7287 201.741 70.0362 197.205 69.2417 194.592C69.2139 194.5 69.1766 194.412 69.13 194.328L51.6188 152.976L43.095 108.593Z",
    fill: "url(#paint0_linear_595_17666)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4218 188.029C33.0286 177.295 35.879 162.909 38.109 157.456C35.8351 164.835 40.9416 179.827 43.7791 186.4C43.2135 186.28 41.6388 184.81 40.5915 185.129C39.2546 185.535 38.7352 187.025 38.4218 188.029Z",
    fill: "#FC5C5C"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6716 182.784C54.1775 170.865 43.8016 160.5 38.914 157.211C44.9103 162.075 49.0126 177.373 50.3143 184.413C50.7172 183.998 51.2073 181.901 52.2546 181.582C53.5915 181.176 54.8521 182.124 55.6716 182.784Z",
    fill: "#FC5C5C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_595_17666",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 157,
    width: 18,
    height: 28
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6716 182.784C54.1775 170.865 43.8016 160.5 38.914 157.211C44.9103 162.075 49.0126 177.373 50.3143 184.413C50.7172 183.998 51.2073 181.901 52.2546 181.582C53.5915 181.176 54.8521 182.124 55.6716 182.784Z",
    fill: "#FC5C5C"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_595_17666)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_595_17666)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.4692,
    cy: 198.78,
    rx: 19.6446,
    ry: 11.6034,
    transform: "rotate(-16.9111 55.4692 198.78)",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_595_17666",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 157,
    width: 9,
    height: 32
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4218 188.029C33.0286 177.295 35.879 162.908 38.109 157.456C35.8351 164.835 40.9416 179.826 43.7791 186.4C43.2135 186.28 41.6388 184.81 40.5915 185.128C39.2546 185.535 38.7352 187.024 38.4218 188.029Z",
    fill: "#FC5C5C"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_595_17666)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_595_17666)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.6446,
    cy: 11.6034,
    rx: 19.6446,
    ry: 11.6034,
    transform: "matrix(-0.956757 0.290888 0.290888 0.956757 62.9128 184.388)",
    fill: "white"
  })))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.3348,
    cy: 113.994,
    rx: 18.5631,
    ry: 4.94571,
    transform: "rotate(-16.9111 25.3348 113.994)",
    fill: "url(#paint1_linear_595_17666)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8343 109.057C28.7182 107.573 33.2883 106.759 36.7246 106.64C38.4454 106.58 39.8617 106.695 40.8846 106.974C41.9271 107.26 42.4556 107.684 42.5998 108.158C42.7438 108.631 42.5412 109.279 41.8337 110.096C41.1396 110.898 40.0268 111.782 38.5639 112.69C35.6426 114.503 31.3932 116.371 26.5094 117.856C21.6253 119.341 17.0545 120.154 13.6182 120.274C11.8974 120.334 10.481 120.219 9.45811 119.939C8.41545 119.654 7.88755 119.229 7.74357 118.755C7.59982 118.282 7.8018 117.635 8.50903 116.818C9.20308 116.016 10.3159 115.132 11.7788 114.224C14.7002 112.411 18.9502 110.542 23.8343 109.057Z",
    stroke: "#FFF5E9",
    strokeWidth: 0.694754
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_595_17666",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 192,
    width: 37,
    height: 16
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2417 194.592C70.0362 197.206 62.7287 201.742 52.9199 204.724C43.1111 207.706 34.5154 208.005 33.7209 205.392C32.9263 202.778 40.2338 198.242 50.0426 195.26C59.8514 192.278 68.4471 191.979 69.2417 194.592Z",
    fill: "#FFF5E9"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_595_17666)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_595_17666",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 147,
    width: 39,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.5249,
    y: 158.7,
    width: 37.1263,
    height: 8.43,
    transform: "rotate(-16.9111 19.5249 158.7)",
    fill: "#E74747"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_595_17666)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_595_17666)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.5366,
    cy: 144.259,
    rx: 11.4049,
    ry: 6.73654,
    transform: "rotate(-16.9111 34.5366 144.259)",
    fill: "#FFBB00"
  })))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6652 170.92C28.0307 168.732 29.5345 165.45 29.5345 161.78C29.5345 155.192 24.688 149.851 18.7096 149.851C12.7312 149.851 7.62915 155.192 7.62915 161.78C7.62915 166.748 9.27128 171.007 13.191 172.801C10.7916 175.088 10.1085 178.544 10.1085 182.411C10.1085 189.297 15.4793 194.879 21.4577 194.879C27.4361 194.879 32.2825 189.297 32.2825 182.411C32.2825 177.244 29.5536 172.811 25.6652 170.92Z",
    fill: "#946555"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.4029 174.963C77.0379 172.069 75.6317 169.114 73.2382 166.713C68.1924 161.651 60.6695 160.969 56.4355 165.19C52.2014 169.41 52.8595 176.935 57.9053 181.997C62.8541 186.962 70.1858 187.713 74.4603 183.758C76.0212 183.68 77.607 183.27 78.0717 182.108C78.5968 180.796 78.0559 177.64 77.4029 174.963Z",
    fill: "#946555"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_595_17666",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 162,
    width: 26,
    height: 25
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.4029 174.963C77.0379 172.069 75.6317 169.114 73.2382 166.713C68.1924 161.651 60.6695 160.969 56.4355 165.19C52.2014 169.41 52.8595 176.935 57.9053 181.997C62.8541 186.962 70.1858 187.713 74.4603 183.758C76.0212 183.68 77.607 183.27 78.0717 182.108C78.5968 180.796 78.0559 177.64 77.4029 174.963Z",
    fill: "#946555"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_595_17666)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_595_17666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.102 193.245C47.5914 194.419 56.2359 187.678 57.41 178.188C58.5841 168.699 51.8432 160.054 42.3537 158.88C32.8643 157.706 24.2199 164.447 23.0458 173.937C21.8717 183.426 28.6126 192.07 38.102 193.245Z",
    fill: "#F46940"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_595_17666",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 149,
    width: 26,
    height: 46
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6652 170.92C28.0307 168.732 29.5345 165.45 29.5345 161.78C29.5345 155.192 24.688 149.851 18.7096 149.851C12.7312 149.851 7.62915 155.192 7.62915 161.78C7.62915 166.748 9.27128 171.007 13.191 172.801C10.7916 175.088 10.1085 178.544 10.1085 182.411C10.1085 189.297 15.4793 194.879 21.4577 194.879C27.4361 194.879 32.2825 189.297 32.2825 182.411C32.2825 177.244 29.5536 172.811 25.6652 170.92Z",
    fill: "#946555"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_595_17666)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_595_17666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.3098 186.912C46.7992 188.086 55.4437 181.345 56.6178 171.855C57.7919 162.366 51.0509 153.722 41.5615 152.547C32.0721 151.373 23.4276 158.114 22.2535 167.604C21.0795 177.093 27.8204 185.738 37.3098 186.912Z",
    fill: "#F46940"
  })))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6125 58.3427L94.9228 39.8273C94.349 33.5405 99.2986 28.1187 105.612 28.1187H151.481C157.83 28.1187 162.791 33.5982 162.162 39.9151L160.31 58.5134C160.092 60.7104 159.176 62.7917 157.285 63.9313C153.45 66.2421 144.984 69.6883 128.595 69.6883C112.342 69.6883 103.759 66.2989 99.7974 63.9889C97.7999 62.8242 96.8227 60.6453 96.6125 58.3427Z",
    fill: "#3B090A"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M172.707 30.1838L172.707 32.504",
    stroke: "#5C282A",
    strokeWidth: 1.37003
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4734 30.3838L84.4734 32.5039",
    stroke: "#5C282A",
    strokeWidth: 1.37003
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 166.032,
    y: 33.6101,
    width: 2.17044,
    height: 22.7533,
    fill: "#FFAE00"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M125.86 14.7854C127.79 14.0496 129.922 14.0436 131.856 14.7685L171.58 29.6578C174.018 30.5717 174.027 34.017 171.594 34.9446L131.331 50.2965C129.401 51.0324 127.269 51.0384 125.335 50.3135L85.6113 35.4242C83.1731 34.5103 83.1634 31.065 85.5964 30.1373L125.86 14.7854Z",
    fill: "#5C292A"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M125.86 12.5437C127.79 11.8079 129.922 11.8019 131.856 12.5268L171.58 27.4161C174.018 28.33 174.027 31.7753 171.594 32.7029L131.331 48.0548C129.401 48.7907 127.269 48.7967 125.335 48.0718L85.6113 33.1825C83.1731 32.2686 83.1634 28.8233 85.5964 27.8956L125.86 12.5437Z",
    fill: "#3B090A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.52649,
    cy: 2.52649,
    r: 2.52649,
    transform: "matrix(1 0 0 -1 164.591 60.1877)",
    fill: "#FFAE00"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8567 158.404L23.2752 154.181L36.3711 154.503L38.3144 160.895C38.3144 160.895 37.0551 167.733 28.2127 170.421C25.7919 171.157 23.9462 171.61 22.5421 171.879C19.7234 172.418 17.8614 170.517 17.2273 167.718L16.6181 165.029L13.8567 158.404Z",
    fill: "#FC5C5C"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3713 154.503C36.6217 155.327 30.8987 155.644 24.3275 157.642C14.8358 161.051 14.6136 160.216 14.3633 159.393C14.113 158.569 10.8243 155.981 22.8222 152.691C30.4163 150.608 36.121 153.68 36.3713 154.503Z",
    fill: "#E74747"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5904 144.499L49.4155 146.234L38.715 153.791L40.6584 160.183C40.6584 160.183 45.5107 165.163 54.3531 162.474C56.7739 161.738 58.5591 161.086 59.8752 160.528C62.5173 159.408 63.0062 156.792 61.975 154.114L60.9842 151.541L59.5904 144.499Z",
    fill: "#FC5C5C"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7149 153.791C38.9652 154.615 43.8963 151.693 50.4675 149.695C60.2504 147.244 59.9702 146.426 59.7199 145.603C59.4696 144.78 60.7612 140.799 48.9622 144.744C41.494 147.24 38.4646 152.968 38.7149 153.791Z",
    fill: "#E74747"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7701 153.568C34.7229 153.886 34.132 154.993 34.4506 156.041L36.2951 162.108C36.6136 163.155 37.7206 163.746 38.7677 163.428C39.3561 163.249 39.8003 162.82 40.0202 162.294C40.4957 162.609 41.1031 162.717 41.6915 162.539C42.7389 162.22 43.3298 161.113 43.0113 160.066L41.1668 153.999C40.8482 152.951 39.7413 152.361 38.6939 152.679C38.1055 152.858 37.6613 153.286 37.4414 153.812C37.3668 153.763 37.2894 153.719 37.2089 153.68C36.7761 153.471 36.2662 153.417 35.7701 153.568Z",
    fill: "#FC5C5C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_595_17666",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 152,
    width: 10,
    height: 12
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7701 153.568C34.7229 153.886 34.132 154.993 34.4506 156.041L36.2951 162.108C36.6136 163.155 37.7206 163.746 38.7677 163.428C39.3561 163.249 39.8003 162.82 40.0202 162.294C40.4957 162.609 41.1031 162.717 41.6915 162.539C42.7389 162.22 43.3298 161.113 43.0113 160.066L41.1668 153.999C40.8482 152.951 39.7413 152.361 38.6939 152.679C38.1055 152.858 37.6613 153.286 37.4414 153.812C37.3668 153.763 37.2894 153.719 37.2089 153.68C36.7761 153.471 36.2662 153.417 35.7701 153.568Z",
    fill: "#F57045"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_595_17666)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_595_17666)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.6582,
    cy: 177.55,
    rx: 19.6446,
    ry: 11.6034,
    transform: "rotate(-16.9111 44.6582 177.55)",
    fill: "white"
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_595_17666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.238 250.577C187.127 251.828 177.917 244.646 176.666 234.535C175.415 224.424 182.597 215.214 192.708 213.963C202.819 212.712 212.029 219.894 213.28 230.005C214.531 240.116 207.349 249.326 197.238 250.577Z",
    fill: "#F46940"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.295 192.546C139.671 178.047 134.515 182.012 132.273 177.684C130.031 173.355 131.068 170.061 134.118 167.011C138.536 162.593 144.244 164.04 147.294 167.09C154.376 174.172 162.919 187.719 157.796 195.146C156.674 198.814 154.772 201.829 152.821 204.026C151.844 205.127 150.766 206.122 149.637 206.928C148.701 207.596 147.02 208.655 144.887 209.01C140.632 209.718 136.609 206.842 135.901 202.587C134.938 196.797 138.447 197.848 141.295 192.546Z",
    fill: "#946555"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_595_17666",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 131,
    y: 164,
    width: 29,
    height: 46
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.294 192.546C139.67 178.047 134.515 182.012 132.273 177.684C130.03 173.356 131.067 170.061 134.118 167.011C138.536 162.593 144.244 164.04 147.294 167.09C154.376 174.173 162.919 187.719 157.795 195.146C156.674 198.814 154.772 201.829 152.821 204.026C151.844 205.127 150.766 206.122 149.637 206.928C148.701 207.597 147.02 208.655 144.887 209.01C140.632 209.718 136.609 206.842 135.901 202.587C134.938 196.798 138.446 197.849 141.294 192.546Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_595_17666)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_595_17666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.83 164.237C130.341 165.411 121.696 158.67 120.522 149.181C119.348 139.691 126.089 131.047 135.578 129.873C145.068 128.699 153.712 135.44 154.886 144.929C156.06 154.418 149.32 163.063 139.83 164.237Z",
    fill: "#F46940"
  })))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.215 200.135C126.965 194.027 120.433 195.141 115.569 194.822C110.704 194.502 108.421 191.911 107.388 187.723C105.891 181.657 110.082 177.52 114.27 176.487C123.994 174.088 147.266 179.131 150.973 187.357C153.533 190.214 155.13 193.4 156.001 196.207C156.438 197.612 156.732 199.05 156.838 200.432C156.926 201.579 156.963 203.566 156.164 205.575C154.569 209.583 150.027 211.539 146.019 209.944C140.566 207.774 143.28 205.315 140.215 200.135Z",
    fill: "#946555"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_595_17666",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 107,
    y: 175,
    width: 50,
    height: 36
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.215 200.135C126.965 194.027 120.433 195.14 115.569 194.821C110.704 194.502 108.421 191.911 107.388 187.723C105.891 181.656 110.082 177.519 114.27 176.486C123.994 174.087 147.266 179.13 150.973 187.356C153.533 190.213 155.13 193.4 156.001 196.206C156.438 197.612 156.732 199.049 156.838 200.432C156.926 201.579 156.963 203.565 156.164 205.574C154.569 209.582 150.027 211.539 146.019 209.944C140.566 207.774 143.28 205.315 140.215 200.135Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_595_17666)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_595_17666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.162 204.792C95.6725 205.966 87.028 199.226 85.8539 189.736C84.6798 180.247 91.4207 171.602 100.91 170.428C110.4 169.254 119.044 175.995 120.218 185.484C121.392 194.974 114.651 203.618 105.162 204.792Z",
    fill: "#F46940"
  })))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.302 216.143C159.575 214.106 160.182 205.978 157.805 197.487C155.427 188.996 147.604 183.764 140.332 185.8C137.217 186.673 134.708 188.737 133.045 191.479C125.453 193.664 123.656 197.991 125.099 203.142C126.213 207.119 128.995 209.974 133.396 209.552C137.812 217.227 146.111 217.876 152.302 216.143Z",
    fill: "#946555"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_595_17666",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 124,
    y: 185,
    width: 36,
    height: 32
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.302 216.143C159.575 214.106 160.182 205.978 157.805 197.487C155.427 188.996 147.604 183.764 140.332 185.8C137.217 186.673 134.708 188.737 133.045 191.479C125.453 193.664 123.656 197.991 125.099 203.142C126.213 207.119 128.995 209.974 133.396 209.552C137.812 217.227 146.111 217.876 152.302 216.143Z",
    fill: "#946555"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_595_17666)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_595_17666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.993 237.639C116.503 238.813 107.859 232.072 106.685 222.583C105.511 213.093 112.252 204.449 121.741 203.275C131.23 202.101 139.875 208.842 141.049 218.331C142.223 227.82 135.482 236.465 125.993 237.639Z",
    fill: "#F46940"
  }))))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M194.225 215.519C201.145 202.687 175.215 181.768 159.597 177.475C120.307 166.674 136.796 200.117 147.699 207.321C156.384 213.059 182.555 237.158 194.225 215.519Z",
    fill: "#956351"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M210.845 39.5745C203.818 32.2668 192.668 31.3209 184.572 36.8739C184.014 27.4116 176.893 19.3156 167.145 17.8792C157.785 16.5041 148.982 21.7009 145.409 29.9896C143.199 20.8834 134.916 14.2122 125.15 14.3932C113.866 14.6151 104.897 23.9431 105.119 35.2273L105.636 61.48C105.855 72.6269 114.961 81.514 126.061 81.514C126.198 81.514 126.335 81.514 126.472 81.5111C132.91 81.3856 138.592 78.2908 142.247 73.5611C145.181 79.1463 150.649 83.3037 157.367 84.2934C158.377 84.4423 159.379 84.5124 160.369 84.5124C160.599 84.5124 160.83 84.5037 161.061 84.4978C161.49 85.0496 161.954 85.5839 162.447 86.0977C166.459 90.2727 171.816 92.3719 177.182 92.3719C182.549 92.3719 187.38 90.4771 191.342 86.6671L210.27 68.4694C218.407 60.6479 218.661 47.7084 210.839 39.5716L210.845 39.5745Z",
    fill: "#FFF5E9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_595_17666",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 105,
    y: 14,
    width: 112,
    height: 62
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M202.639 75.8734L210.341 68.4694C218.478 60.6479 218.732 47.7084 210.911 39.5716C203.883 32.2639 192.733 31.318 184.637 36.871C184.08 27.4087 176.959 19.3127 167.211 17.8763C157.85 16.5012 149.048 21.698 145.474 29.9866C143.264 20.8834 134.982 14.2122 125.216 14.3932C113.931 14.6151 104.963 23.9431 105.184 35.2273L105.453 48.8383C110.977 48.2485 116.658 47.9507 122.46 47.9507C155.602 47.9507 184.903 57.6699 202.639 75.8734Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_595_17666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.185 19.5989C112.1 60.1399 184.252 82.4746 217.993 46.6253L223.018 87.8495L82.4668 68.3643L104.185 19.5989Z",
    fill: "#F9E4CF"
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M224.898 122.948C224.898 169.418 181.017 188.772 126.889 188.772C72.7599 188.772 28.8789 169.418 28.8789 122.948C28.8789 76.477 72.7599 50.5601 126.889 50.5601C181.017 50.5601 224.898 76.477 224.898 122.948Z",
    fill: "#FFF5E9"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M224.898 122.948C224.898 169.418 181.017 188.772 126.889 188.772C72.7599 188.772 28.8789 169.418 28.8789 122.948C28.8789 76.477 72.7599 50.5601 126.889 50.5601C181.017 50.5601 224.898 76.477 224.898 122.948Z",
    fill: "url(#paint2_linear_595_17666)",
    fillOpacity: 0.2
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M197.656 127.696C197.656 160.518 165.973 176.252 126.889 176.252C87.8044 176.252 56.1213 160.518 56.1213 127.696C56.1213 94.8746 87.8044 78.6301 126.889 78.6301C165.973 78.6301 197.656 94.8717 197.656 127.696Z",
    fill: "#946555"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_595_17666",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 78,
    width: 142,
    height: 99
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M197.656 127.697C197.656 160.518 165.973 176.252 126.889 176.252C87.8044 176.252 56.1213 160.518 56.1213 127.697C56.1213 94.8748 87.8044 78.6304 126.889 78.6304C165.973 78.6304 197.656 94.8719 197.656 127.697Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_595_17666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.9351 171.269C92.2215 171.269 102.992 160.498 102.992 147.212C102.992 133.926 92.2215 123.155 78.9351 123.155C65.6487 123.155 54.8779 133.926 54.8779 147.212C54.8779 160.498 65.6487 171.269 78.9351 171.269Z",
    fill: "#B7654F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.842 171.268C188.129 171.268 198.9 160.497 198.9 147.211C198.9 133.924 188.129 123.154 174.842 123.154C161.556 123.154 150.785 133.924 150.785 147.211C150.785 160.497 161.556 171.268 174.842 171.268Z",
    fill: "#B7654F"
  }))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M108.893 123.226C104.612 127.506 99.1909 129.027 95.1998 125.036C91.2088 121.045 92.7299 115.626 97.01 111.343C101.29 107.063 106.712 105.542 110.703 109.533C114.694 113.524 113.173 118.943 108.893 123.226Z",
    fill: "#3B090A"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M111.056 135.135C106.776 139.415 101.354 140.936 97.3632 136.945C93.3721 132.954 94.8932 127.535 99.1733 123.252C103.453 118.972 108.875 117.451 112.866 121.442C116.857 125.433 115.336 130.852 111.056 135.135Z",
    fill: "#3B090A"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M104.473 118.499C102.464 120.508 100.093 121.398 98.5811 119.886C97.0687 118.373 97.9563 116.003 99.9679 113.994C101.977 111.985 104.347 111.095 105.86 112.607C107.372 114.12 106.484 116.49 104.473 118.499Z",
    fill: "#FFF5E9"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M106.902 132.44C105.08 134.262 102.861 135 101.349 133.488C99.8362 131.976 100.575 129.757 102.397 127.935C104.218 126.113 106.437 125.375 107.95 126.887C109.462 128.399 108.723 130.618 106.902 132.44Z",
    fill: "#FFC160"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M107.763 122.937C106.899 123.801 105.824 124.125 105.057 123.357C104.289 122.589 104.613 121.512 105.477 120.651C106.341 119.79 107.416 119.463 108.183 120.23C108.951 120.998 108.627 122.076 107.763 122.937Z",
    fill: "#B7654F"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M154.601 123.226C150.321 127.506 144.9 129.027 140.909 125.036C136.918 121.045 138.439 115.626 142.719 111.343C146.999 107.06 152.42 105.542 156.411 109.533C160.402 113.524 158.881 118.943 154.601 123.226Z",
    fill: "#3B090A"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M156.768 135.134C152.488 139.414 147.066 140.935 143.075 136.944C139.084 132.953 140.605 127.534 144.885 123.251C149.165 118.971 154.587 117.45 158.578 121.441C162.569 125.432 161.048 130.851 156.768 135.134Z",
    fill: "#3B090A"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M150.184 118.499C148.175 120.507 145.805 121.398 144.292 119.885C142.78 118.373 143.667 116.002 145.679 113.994C147.688 111.985 150.058 111.095 151.571 112.607C153.083 114.119 152.195 116.49 150.184 118.499Z",
    fill: "#FFF5E9"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M152.613 132.44C150.791 134.261 148.572 135 147.06 133.488C145.548 131.975 146.286 129.757 148.108 127.935C149.93 126.113 152.149 125.374 153.661 126.887C155.173 128.399 154.435 130.618 152.613 132.44Z",
    fill: "#FFC160"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M153.474 122.936C152.61 123.801 151.535 124.125 150.768 123.357C150 122.589 150.324 121.512 151.188 120.65C152.052 119.786 153.127 119.462 153.894 120.23C154.662 120.998 154.338 122.075 153.474 122.936Z",
    fill: "#B7654F"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M131.248 137.159C131.23 137.159 131.216 137.159 131.198 137.159C129.695 137.144 128.249 136.414 126.886 134.984C125.523 136.414 124.077 137.144 122.574 137.159C122.559 137.159 122.542 137.159 122.524 137.159C120.191 137.159 118.778 135.422 118.624 135.223C118.13 134.587 118.247 133.67 118.883 133.173C119.517 132.683 120.428 132.794 120.921 133.422C120.953 133.46 121.616 134.239 122.527 134.239C122.539 134.239 122.55 134.239 122.562 134.239C123.461 134.219 124.492 133.457 125.546 132.038C125.82 131.667 126.255 131.448 126.717 131.448H127.044C127.505 131.448 127.94 131.667 128.214 132.038C129.268 133.457 130.299 134.219 131.198 134.239C131.21 134.239 131.222 134.239 131.233 134.239C132.162 134.239 132.833 133.43 132.839 133.422C133.332 132.785 134.246 132.674 134.883 133.168C135.519 133.661 135.63 134.584 135.137 135.223C134.982 135.422 133.569 137.159 131.236 137.159H131.248Z",
    fill: "#3B090A"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M164.747 145.458C164.373 145.458 163.999 145.315 163.713 145.031C163.144 144.462 163.144 143.537 163.713 142.967L169.952 136.728C170.522 136.159 171.447 136.159 172.017 136.728C172.586 137.298 172.586 138.223 172.017 138.792L165.777 145.031C165.491 145.318 165.118 145.458 164.744 145.458H164.747Z",
    fill: "#AF4F3C"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M172.606 145.458C172.233 145.458 171.859 145.315 171.573 145.032C171.003 144.462 171.003 143.537 171.573 142.967L175.19 139.35C175.759 138.781 176.685 138.781 177.254 139.35C177.824 139.919 177.824 140.845 177.254 141.414L173.637 145.032C173.351 145.318 172.977 145.458 172.603 145.458H172.606Z",
    fill: "#AF4F3C"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M176.223 141.841C175.849 141.841 175.476 141.698 175.19 141.415C174.62 140.846 174.62 139.92 175.19 139.351L177.814 136.726C178.384 136.157 179.309 136.157 179.878 136.726C180.448 137.295 180.448 138.221 179.878 138.79L177.254 141.415C176.968 141.701 176.594 141.841 176.22 141.841H176.223Z",
    fill: "#AF4F3C"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M180.462 145.458C180.089 145.458 179.715 145.315 179.429 145.031C178.86 144.462 178.86 143.537 179.429 142.967L185.668 136.728C186.237 136.159 187.163 136.159 187.732 136.728C188.301 137.298 188.301 138.223 187.732 138.792L181.493 145.031C181.207 145.318 180.833 145.458 180.46 145.458H180.462Z",
    fill: "#AF4F3C"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0731 145.458C66.6993 145.458 66.3257 145.315 66.0395 145.032C65.4702 144.462 65.4702 143.537 66.0395 142.968L72.2786 136.728C72.848 136.159 73.7735 136.159 74.3428 136.728C74.9121 137.298 74.9121 138.223 74.3428 138.793L68.1037 145.032C67.8176 145.318 67.4438 145.458 67.0701 145.458H67.0731Z",
    fill: "#AF4F3C"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9324 145.458C74.5587 145.458 74.185 145.315 73.8989 145.032C73.3296 144.462 73.3296 143.537 73.8989 142.968L77.5163 139.35C78.0856 138.781 79.0111 138.781 79.5804 139.35C80.1497 139.92 80.1497 140.845 79.5804 141.414L75.963 145.032C75.6769 145.318 75.3032 145.458 74.9295 145.458H74.9324Z",
    fill: "#AF4F3C"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5464 141.841C78.1727 141.841 77.799 141.698 77.5129 141.415C76.9436 140.846 76.9436 139.92 77.5129 139.351L80.1376 136.726C80.7069 136.157 81.6324 136.157 82.2017 136.726C82.7711 137.296 82.7711 138.221 82.2017 138.79L79.5771 141.415C79.2909 141.701 78.9172 141.841 78.5435 141.841H78.5464Z",
    fill: "#AF4F3C"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7886 145.458C82.4149 145.458 82.0412 145.315 81.7551 145.032C81.1858 144.462 81.1858 143.537 81.7551 142.968L87.9942 136.728C88.5635 136.159 89.489 136.159 90.0584 136.728C90.6277 137.298 90.6277 138.223 90.0584 138.793L83.8192 145.032C83.5331 145.318 83.1594 145.458 82.7857 145.458H82.7886Z",
    fill: "#AF4F3C"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.4427,
    cy: 186.042,
    rx: 19.8319,
    ry: 22.3845,
    transform: "rotate(-73.9599 39.4427 186.042)",
    fill: "#946555"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.3424 108.931L5.80249 119.736L23.4347 161.375L31.9095 205.502C31.9178 205.597 31.9355 205.689 31.9628 205.78L31.963 205.781L31.9632 205.781C31.9632 205.781 31.9632 205.781 31.9632 205.781C32.7582 208.396 41.3585 208.096 51.1726 205.113C60.9867 202.129 68.2981 197.59 67.5031 194.976C67.4753 194.884 67.438 194.796 67.3914 194.712L49.8708 153.337L41.3424 108.931Z",
    fill: "#FFF5E9"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.3424 108.931L5.80249 119.736L23.4347 161.375L31.9095 205.502C31.9178 205.597 31.9355 205.689 31.9628 205.78L31.963 205.781L31.9632 205.781C31.9632 205.781 31.9632 205.781 31.9632 205.781C32.7582 208.396 41.3585 208.096 51.1726 205.113C60.9867 202.129 68.2981 197.59 67.5031 194.976C67.4753 194.884 67.438 194.796 67.3914 194.712L49.8708 153.337L41.3424 108.931Z",
    fill: "url(#paint3_linear_595_17666)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6666 188.409C31.2705 177.669 34.1224 163.275 36.3536 157.819C34.0784 165.202 39.1877 180.202 42.0268 186.779C41.4608 186.659 39.8853 185.188 38.8374 185.507C37.4998 185.913 36.9802 187.404 36.6666 188.409Z",
    fill: "#FC5C5C"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M53.926 183.162C52.4311 171.236 42.0496 160.865 37.1594 157.575C43.1589 162.442 47.2634 177.747 48.5658 184.791C48.9689 184.376 49.4593 182.278 50.5072 181.959C51.8448 181.552 53.1061 182.501 53.926 183.162Z",
    fill: "#FC5C5C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_595_17666",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 157,
    width: 17,
    height: 28
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9257 183.162C52.4309 171.236 42.0494 160.865 37.1591 157.575C43.1586 162.442 47.2632 177.747 48.5655 184.791C48.9687 184.376 49.4591 182.278 50.5069 181.959C51.8446 181.552 53.1059 182.501 53.9257 183.162Z",
    fill: "#FC5C5C"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_595_17666)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_595_17666)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.7233,
    cy: 199.166,
    rx: 19.6551,
    ry: 11.6097,
    transform: "rotate(-16.9111 53.7233 199.166)",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_595_17666",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 157,
    width: 10,
    height: 32
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6668 188.409C31.2707 177.669 34.1227 163.275 36.3538 157.819C34.0787 165.202 39.188 180.202 42.027 186.779C41.4611 186.659 39.8855 185.188 38.8377 185.507C37.5 185.913 36.9804 187.404 36.6668 188.409Z",
    fill: "#FC5C5C"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_595_17666)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_f_595_17666)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.6551,
    cy: 11.6097,
    rx: 19.6551,
    ry: 11.6097,
    transform: "matrix(-0.956757 0.290888 0.290888 0.956757 61.1711 184.766)",
    fill: "white"
  })))), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.5724,
    cy: 114.334,
    rx: 18.5731,
    ry: 4.94837,
    transform: "rotate(-16.9111 23.5724 114.334)",
    fill: "url(#paint4_linear_595_17666)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0709 109.395C26.9576 107.909 31.5308 107.096 34.969 106.976C36.6904 106.916 38.1069 107.031 39.1302 107.311C40.1735 107.597 40.7025 108.021 40.8466 108.495C40.9907 108.969 40.7875 109.616 40.0796 110.434C39.3852 111.236 38.2726 112.12 36.8092 113.029C33.8863 114.843 29.6341 116.713 24.7474 118.198C19.8607 119.684 15.2876 120.498 11.8494 120.617C10.1277 120.677 8.71058 120.562 7.68719 120.282C6.64413 119.997 6.11576 119.572 5.97171 119.098C5.82773 118.624 6.0301 117.977 6.73783 117.16C7.43224 116.358 8.54552 115.473 10.0092 114.565C12.9321 112.75 17.1842 110.881 22.0709 109.395Z",
    stroke: "#FFF5E9",
    strokeWidth: 0.695128
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_595_17666",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 193,
    width: 37,
    height: 15
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5033 194.976C68.2982 197.591 60.9868 202.129 51.1727 205.113C41.3586 208.097 32.7583 208.396 31.9633 205.782C31.1684 203.167 38.4798 198.628 48.2939 195.644C58.108 192.661 66.7083 192.361 67.5033 194.976Z",
    fill: "#FFF5E9"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_595_17666)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_595_17666",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 148,
    width: 39,
    height: 20
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 17.7595,
    y: 159.065,
    width: 37.1462,
    height: 8.43453,
    transform: "rotate(-16.9111 17.7595 159.065)",
    fill: "#E74747"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_595_17666)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_f_595_17666)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.7791,
    cy: 144.616,
    rx: 11.4111,
    ry: 6.74016,
    transform: "rotate(-16.9111 32.7791 144.616)",
    fill: "#FFBB00"
  })))), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9031 171.291C26.2699 169.102 27.7745 165.818 27.7745 162.146C27.7745 155.554 22.9254 150.211 16.9438 150.211C10.9622 150.211 5.85742 155.554 5.85742 162.146C5.85742 167.117 7.50043 171.378 11.4223 173.173C9.02154 175.461 8.3381 178.919 8.3381 182.788C8.3381 189.678 13.7118 195.263 19.6934 195.263C25.675 195.263 30.5241 189.678 30.5241 182.788C30.5241 177.619 27.7936 173.183 23.9031 171.291Z",
    fill: "#946555"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.6689 175.336C75.3036 172.441 73.8967 169.484 71.5019 167.082C66.4534 162.017 58.9265 161.335 54.6902 165.558C50.4538 169.781 51.1122 177.31 56.1607 182.374C61.1123 187.341 68.4478 188.093 72.7247 184.136C74.2864 184.058 75.8731 183.648 76.338 182.485C76.8634 181.172 76.3222 178.015 75.6689 175.336Z",
    fill: "#946555"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_595_17666",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 51,
    y: 162,
    width: 26,
    height: 25
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.6689 175.336C75.3036 172.441 73.8967 169.484 71.5019 167.082C66.4534 162.017 58.9265 161.335 54.6902 165.558C50.4538 169.781 51.1122 177.31 56.1607 182.374C61.1123 187.341 68.4478 188.093 72.7247 184.136C74.2864 184.058 75.8731 183.648 76.338 182.485C76.8634 181.172 76.3222 178.015 75.6689 175.336Z",
    fill: "#946555"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_595_17666)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_f_595_17666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.3468 193.627C45.8413 194.802 54.4904 188.057 55.6651 178.563C56.8398 169.068 50.0953 160.419 40.6008 159.244C31.1062 158.07 22.4571 164.814 21.2824 174.309C20.1077 183.803 26.8522 192.452 36.3468 193.627Z",
    fill: "#F46940"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_595_17666",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 150,
    width: 26,
    height: 46
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9031 171.291C26.2699 169.102 27.7745 165.817 27.7745 162.146C27.7745 155.554 22.9254 150.211 16.9438 150.211C10.9622 150.211 5.85742 155.554 5.85742 162.146C5.85742 167.117 7.50043 171.378 11.4223 173.173C9.02154 175.461 8.3381 178.919 8.3381 182.788C8.3381 189.678 13.7118 195.263 19.6934 195.263C25.675 195.263 30.5241 189.678 30.5241 182.788C30.5241 177.618 27.7936 173.183 23.9031 171.291Z",
    fill: "#946555"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_595_17666)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_f_595_17666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.4984 186.056C46.9929 187.225 55.642 180.512 56.8168 171.062C57.9915 161.612 51.2469 153.003 41.7524 151.834C32.2579 150.665 23.6087 157.378 22.434 166.828C21.2593 176.278 28.0039 184.886 37.4984 186.056Z",
    fill: "#F46940"
  })))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 166.291,
    y: 33.5051,
    width: 2.17161,
    height: 22.7656,
    fill: "#FFAE00"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M96.833 58.2515L95.1424 39.7262C94.5683 33.436 99.5205 28.0112 105.837 28.0112H151.731C158.083 28.0112 163.047 33.4938 162.418 39.814L160.565 58.4223C160.346 60.6205 159.43 62.7029 157.538 63.8431C153.701 66.1551 145.231 69.6033 128.833 69.6033C112.571 69.6033 103.984 66.212 100.02 63.9007C98.021 62.7355 97.0432 60.5554 96.833 58.2515Z",
    fill: "#3B090A"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M126.096 14.6709C128.027 13.9347 130.16 13.9286 132.095 14.654L171.84 29.5513C174.279 30.4656 174.289 33.9128 171.855 34.841L131.569 50.2011C129.638 50.9373 127.505 50.9434 125.57 50.218L85.8254 35.3208C83.3859 34.4064 83.3762 30.9592 85.8104 30.0311L126.096 14.6709Z",
    fill: "#5C292A"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M172.969 30.0774L172.969 32.3988",
    stroke: "#5C282A",
    strokeWidth: 1.37077
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6875 30.2773L84.6875 32.3986",
    stroke: "#5C282A",
    strokeWidth: 1.37077
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M126.096 12.428C128.027 11.6918 130.16 11.6857 132.095 12.411L171.84 27.3083C174.279 28.2227 174.289 31.6699 171.855 32.598L131.569 47.9582C129.638 48.6944 127.505 48.7004 125.57 47.9751L85.8254 33.0779C83.3859 32.1635 83.3762 28.7163 85.8104 27.7882L126.096 12.428Z",
    fill: "#3B090A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.52785,
    cy: 2.52785,
    r: 2.52785,
    transform: "matrix(1 0 0 -1 164.849 60.0981)",
    fill: "#FFAE00"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0344 157.642L23.4459 153.447L36.5419 153.788L38.4953 160.164C38.4953 160.164 37.2468 166.979 28.4089 169.646C25.9953 170.374 24.1534 170.822 22.751 171.088C19.9269 171.624 18.057 169.721 17.4166 166.921L16.8062 164.252L14.0344 157.642Z",
    fill: "#FC5C5C"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5585 153.799C36.8103 154.621 31.0844 154.929 24.5125 156.914C15.0205 160.302 14.7968 159.468 14.5451 158.646C14.2933 157.824 10.9986 155.235 22.9984 151.968C30.5938 149.901 36.3067 152.977 36.5585 153.799Z",
    fill: "#E74747"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7703 143.823L49.5985 145.536L38.9103 153.053L40.8636 159.429C40.8636 159.429 45.7237 164.401 54.5615 161.735C56.9752 161.007 58.7564 160.361 60.0707 159.808C62.7175 158.693 63.2036 156.079 62.1651 153.399L61.1752 150.845L59.7703 143.823Z",
    fill: "#FC5C5C"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9134 153.073C39.1651 153.895 44.0945 150.986 50.6665 149.001C60.4514 146.57 60.1697 145.753 59.918 144.931C59.6662 144.108 60.9523 140.136 49.1525 144.056C41.6838 146.537 38.6616 152.251 38.9134 153.073Z",
    fill: "#E74747"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9555 152.846C34.9091 153.162 34.3196 154.264 34.6392 155.308L36.4897 161.354C36.8093 162.398 37.9165 162.987 38.9629 162.671C39.5509 162.494 39.9945 162.068 40.2138 161.544C40.6895 161.858 41.2968 161.966 41.8848 161.789C42.9315 161.473 43.521 160.371 43.2014 159.327L41.3509 153.281C41.0313 152.237 39.9241 151.648 38.8774 151.964C38.2894 152.141 37.8458 152.568 37.6266 153.091C37.552 153.042 37.4746 152.999 37.394 152.96C36.9611 152.751 36.4514 152.697 35.9555 152.846Z",
    fill: "#FC5C5C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_595_17666",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 151,
    width: 10,
    height: 12
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9546 152.844C34.9087 153.16 34.3199 154.261 34.6399 155.306L36.4926 161.353C36.8125 162.397 37.9196 162.988 38.9654 162.672C39.5531 162.495 39.9963 162.069 40.2153 161.545C40.691 161.859 41.2981 161.968 41.8858 161.791C42.9319 161.475 43.5207 160.373 43.2007 159.329L41.348 153.282C41.0281 152.237 39.921 151.647 38.8749 151.963C38.2872 152.14 37.844 152.566 37.6251 153.09C37.5505 153.041 37.4731 152.997 37.3925 152.958C36.9597 152.749 36.4501 152.695 35.9546 152.844Z",
    fill: "#F57045"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_595_17666)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_f_595_17666)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.6258,
    cy: 11.5845,
    rx: 19.6258,
    ry: 11.5845,
    transform: "matrix(0.957366 -0.288886 0.292909 0.956143 22.6687 171.326)",
    fill: "white"
  })))), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M194.924 216.538C201.038 202.259 171.517 182.545 154.532 179.485C111.805 171.787 132.506 205.696 144.766 212.296C154.532 217.553 184.613 240.619 194.924 216.538Z",
    fill: "#946555"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_595_17666",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 128,
    y: 178,
    width: 68,
    height: 50
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M194.924 216.538C201.038 202.259 171.517 182.545 154.532 179.485C111.805 171.787 132.506 205.696 144.766 212.296C154.532 217.553 184.613 240.619 194.924 216.538Z",
    fill: "#946555"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_595_17666)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_f_595_17666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.027 249.622C187.835 250.877 178.551 243.671 177.29 233.527C176.029 223.383 183.269 214.142 193.461 212.887C203.653 211.632 212.937 218.838 214.198 228.982C215.459 239.126 208.219 248.367 198.027 249.622Z",
    fill: "#F46940"
  })))), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.539 192.527C139.915 178.02 134.756 181.987 132.513 177.656C130.269 173.326 131.307 170.029 134.359 166.978C138.779 162.557 144.49 164.005 147.542 167.057C154.628 174.143 163.175 187.697 158.049 195.128C156.927 198.798 155.024 201.815 153.072 204.013C152.094 205.114 151.016 206.11 149.886 206.916C148.95 207.585 147.268 208.644 145.134 208.999C140.876 209.708 136.851 206.83 136.143 202.573C135.179 196.78 138.69 197.832 141.539 192.527Z",
    fill: "#946555"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_595_17666",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 131,
    y: 164,
    width: 29,
    height: 46
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.539 192.526C139.915 178.019 134.756 181.987 132.513 177.656C130.27 173.325 131.307 170.029 134.359 166.978C138.779 162.557 144.49 164.005 147.542 167.057C154.628 174.143 163.176 187.697 158.049 195.128C156.927 198.798 155.024 201.814 153.072 204.013C152.094 205.114 151.016 206.109 149.887 206.916C148.95 207.585 147.268 208.644 145.134 208.999C140.877 209.707 136.851 206.83 136.143 202.573C135.18 196.78 138.69 197.832 141.539 192.526Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_595_17666)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_f_595_17666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.075 163.476C130.58 164.645 121.931 157.932 120.756 148.482C119.582 139.032 126.326 130.423 135.821 129.254C145.315 128.085 153.964 134.798 155.139 144.248C156.314 153.698 149.569 162.306 140.075 163.476Z",
    fill: "#F46940"
  })))), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.458 200.12C127.202 194.008 120.666 195.123 115.799 194.803C110.932 194.484 108.648 191.891 107.614 187.701C106.117 181.631 110.31 177.492 114.5 176.458C124.229 174.058 147.514 179.104 151.223 187.334C153.784 190.193 155.382 193.381 156.254 196.189C156.69 197.595 156.985 199.033 157.091 200.417C157.179 201.565 157.216 203.552 156.416 205.562C154.821 209.572 150.277 211.53 146.266 209.934C140.81 207.763 143.526 205.302 140.458 200.12Z",
    fill: "#946555"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_595_17666",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 107,
    y: 175,
    width: 51,
    height: 36
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.458 200.12C127.202 194.008 120.666 195.123 115.799 194.803C110.932 194.484 108.648 191.891 107.614 187.701C106.117 181.631 110.31 177.492 114.5 176.458C124.229 174.058 147.514 179.104 151.223 187.334C153.784 190.193 155.382 193.381 156.254 196.189C156.69 197.595 156.985 199.033 157.091 200.417C157.179 201.565 157.216 203.552 156.416 205.562C154.821 209.572 150.277 211.53 146.266 209.934C140.81 207.763 143.526 205.302 140.458 200.12Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_595_17666)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_f_595_17666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.387 203.862C95.8928 205.031 87.2437 198.318 86.069 188.868C84.8943 179.418 91.6388 170.81 101.133 169.64C110.628 168.471 119.277 175.184 120.452 184.634C121.626 194.084 114.882 202.693 105.387 203.862Z",
    fill: "#F46940"
  })))), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.553 216.135C159.829 214.097 160.437 205.965 158.058 197.47C155.679 188.974 147.852 183.739 140.576 185.777C137.459 186.649 134.949 188.715 133.285 191.459C125.689 193.644 123.891 197.974 125.334 203.127C126.449 207.107 129.233 209.963 133.636 209.541C138.055 217.22 146.359 217.87 152.553 216.135Z",
    fill: "#946555"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_595_17666",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 124,
    y: 185,
    width: 36,
    height: 32
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.553 216.135C159.829 214.097 160.437 205.965 158.058 197.47C155.679 188.974 147.852 183.739 140.576 185.777C137.459 186.649 134.949 188.715 133.285 191.459C125.689 193.644 123.891 197.974 125.334 203.127C126.449 207.107 129.233 209.963 133.636 209.541C138.055 217.22 146.359 217.87 152.553 216.135Z",
    fill: "#946555"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_595_17666)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_f_595_17666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.229 236.572C116.734 237.741 108.085 231.029 106.91 221.579C105.736 212.129 112.48 203.52 121.975 202.351C131.469 201.182 140.118 207.895 141.293 217.345C142.468 226.794 135.723 235.403 126.229 236.572Z",
    fill: "#F46940"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_595_17666",
    x: -4.84227,
    y: 163.221,
    width: 111.352,
    height: 111.351,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.1804,
    result: "effect1_foregroundBlur_595_17666"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_595_17666",
    x: 19.6165,
    y: 169.537,
    width: 71.7055,
    height: 58.4846,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.37683,
    result: "effect1_foregroundBlur_595_17666"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_595_17666",
    x: 11.6404,
    y: 171.962,
    width: 71.7053,
    height: 58.4846,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.37683,
    result: "effect1_foregroundBlur_595_17666"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_595_17666",
    x: 13.7219,
    y: 127.282,
    width: 41.6294,
    height: 33.9541,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.86328,
    result: "effect1_foregroundBlur_595_17666"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_595_17666",
    x: -15.448,
    y: 120.387,
    width: 111.352,
    height: 111.351,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.1804,
    result: "effect1_foregroundBlur_595_17666"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_595_17666",
    x: -16.2402,
    y: 114.054,
    width: 111.352,
    height: 111.351,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.1804,
    result: "effect1_foregroundBlur_595_17666"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_595_17666",
    x: 8.80543,
    y: 148.308,
    width: 71.7055,
    height: 58.4846,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.37683,
    result: "effect1_foregroundBlur_595_17666"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_595_17666",
    x: 135.652,
    y: 172.948,
    width: 118.643,
    height: 118.643,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20.4364,
    result: "effect1_foregroundBlur_595_17666"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_595_17666",
    x: 82.0286,
    y: 91.3792,
    width: 111.352,
    height: 111.351,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.1804,
    result: "effect1_foregroundBlur_595_17666"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_595_17666",
    x: 47.3604,
    y: 131.935,
    width: 111.352,
    height: 111.351,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.1804,
    result: "effect1_foregroundBlur_595_17666"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_595_17666",
    x: 68.1912,
    y: 164.781,
    width: 111.352,
    height: 111.351,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.1804,
    result: "effect1_foregroundBlur_595_17666"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_595_17666",
    x: 17.8514,
    y: 169.908,
    width: 71.7438,
    height: 58.516,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.38133,
    result: "effect1_foregroundBlur_595_17666"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_595_17666",
    x: 9.87113,
    y: 172.333,
    width: 71.7438,
    height: 58.516,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.38133,
    result: "effect1_foregroundBlur_595_17666"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_595_17666",
    x: 11.9533,
    y: 127.63,
    width: 41.6518,
    height: 33.9724,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.86589,
    result: "effect1_foregroundBlur_595_17666"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_f_595_17666",
    x: -17.2318,
    y: 120.73,
    width: 111.411,
    height: 111.411,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.1907,
    result: "effect1_foregroundBlur_595_17666"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_f_595_17666",
    x: -16.0802,
    y: 113.321,
    width: 111.411,
    height: 111.248,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.1907,
    result: "effect1_foregroundBlur_595_17666"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_f_595_17666",
    x: 8.99198,
    y: 147.524,
    width: 71.7179,
    height: 58.4169,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.38133,
    result: "effect1_foregroundBlur_595_17666"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_f_595_17666",
    x: 135.946,
    y: 171.544,
    width: 119.595,
    height: 119.421,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20.6005,
    result: "effect1_foregroundBlur_595_17666"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_f_595_17666",
    x: 82.2418,
    y: 90.7406,
    width: 111.411,
    height: 111.248,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.1907,
    result: "effect1_foregroundBlur_595_17666"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_f_595_17666",
    x: 47.5546,
    y: 131.127,
    width: 111.411,
    height: 111.248,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.1907,
    result: "effect1_foregroundBlur_595_17666"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_f_595_17666",
    x: 68.3959,
    y: 163.837,
    width: 111.411,
    height: 111.248,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.1907,
    result: "effect1_foregroundBlur_595_17666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_595_17666",
    x1: 30.9262,
    y1: 218.004,
    x2: 92.3758,
    y2: 182.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_595_17666",
    x1: 29.1147,
    y1: 120.784,
    x2: 32.6652,
    y2: 105.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9E4CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_595_17666",
    x1: 43.0026,
    y1: 105.114,
    x2: 29.4364,
    y2: 110.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6664E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_595_17666",
    x1: 29.167,
    y1: 218.401,
    x2: 90.6497,
    y2: 182.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_595_17666",
    x1: 27.3543,
    y1: 121.127,
    x2: 30.9067,
    y2: 105.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9E4CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_595_17666"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.16699,
    y: 2.52051,
    width: 230,
    height: 230,
    rx: 115,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedSheetCharacter);
export default __webpack_public_path__ + "static/media/verifiedSheetCharacter.6bace9297518ddcb58a2a0f414d94298.svg";
export { ForwardRef as ReactComponent };